export const TrueLayerDocumentRequirementContentDE = () => {
  return (
    <>
      <h4>Mein Bankkonto verknüpfen</h4>
      <ul>
        <li>
          Open Banking mit TrueLayer ist ein sicherer Weg, Ihre Kontodaten zu
          teilen, ohne Ihr Passwort weiterzugeben.{' '}
          <a href="https://www.iwoca.de/kredit/open-banking">Mehr erfahren</a>
        </li>
        <li>
          Verknüpfen Sie alle Konten, die mehr als 10% Ihres Gesamtumsatzes
          ausmachen.
        </li>
      </ul>
    </>
  );
};
